import * as React from 'react';

import { ProgramEnum } from 'src/modules/programs/models/programs';
import { StepsQuestion } from 'src/modules/programs/surveys/components/StepsQuestion';
import { SurveyStepsQuestion } from 'src/modules/programs/surveys/models/surveys';
import { GenericProgramSurvey } from 'src/modules/programs/surveys/models/surveysGeneric';

interface Props {
    programId: ProgramEnum;
    surveyId: GenericProgramSurvey;
    questions: SurveyStepsQuestion[];
}

export const HierarchyTableContent: React.SFC<Props> = ({ questions, programId, surveyId }) => {
    return (
        <>
            {questions.map(question => (
                <tr key={question.id}>
                    <StepsQuestion
                        inTable
                        programId={programId}
                        surveyId={surveyId}
                        {...question}
                    />
                </tr>
            ))}
        </>
    );
};
